import types from "./types";

const initialState = {
  user: null,
  loaded: false,
  tokenPointOfOrigin: null,
  tokenPerimeter: null,
  isCertifier: null,
  isReadOnly: null,
  rolesLoaded: false,
  hasNoRoles: false,
  isAdmin: false,
  userSession: null,
  shouldPromptForUserUpdate: false,
  userLayers: [],
  notifications: []
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.AUTH_SUCCESS:
      const authObject = { ...action.payload };
      delete authObject.user.portal;

      if (authObject.user.credential && authObject.user.credential._oAuthCred) {
        delete authObject.user.credential._oAuthCred;
      }

      return {
        ...state,
        ...authObject,
        loaded: true
      }
    case types.AUTH_FAIL:
      return {
        ...state,
        user: null,
        loaded: true
      }
    case types.SET_IS_CERTIFIER:
    return {
      ...state,
      isCertifier: action.payload.isCertifier,
      rolesLoaded: true
    }
    case types.SET_IS_READONLY:
    return {
      ...state,
      isReadOnly: action.payload.isReadOnly,
      rolesLoaded: true
    }

    case types.SET_IS_ADMIN:
      return {
        ...state,
        isAdmin: action.payload.isAdmin
      }

    case types.SET_USER_SESSION:
      return {
        ...state,
        userSession: action.payload.userSession
      }

    case types.SET_USER_LAYERS:
      return {
        ...state,
        userLayers: action.payload.userLayers
      }

      case types.SET_USER_NOTIFICATIONS:
        return {
          ...state,
          notifications: action.payload.notifications
        }

        
    case types.SET_UPDATE_PROMPT:
      return {
        ...state,
        shouldPromptForUserUpdate: action.payload.shouldPrompt
      }

    case types.SET_NO_ROLES:
    return {
      ...state,
      hasNoRoles: action.payload.noRoles
    }

    case types.LOGOUT:
      return {
        ...state,
        user: null
      }

    case types.TOKEN_PERIMETER:
      return {
        ...state,
        tokenPerimeter: action.payload.token
      }
      case types.TOKEN_POO:
        return {
          ...state,
          tokenPointOfOrigin: action.payload.token
        }
    default:
      return state;
  }
}

export default authReducer;
